module.exports = __webpack_public_path__ + "static/media/1.59012081.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/skin-cancer-surgery-mohs/1.jpg
// module id = 665
// module chunks = 0